import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import './Deals.css';
import AdminAppBar from './components/adminComponents/AdminAppBar';
import AdminLeadUploadPanel from './components/adminComponents/AdminLeadUploadPanel'
import AdminBulkUpload from './components/adminComponents/AdminBulkUpload';
import AdminManualUpload from './components/adminComponents/AdminManualUpload';
import AdminPanel from './components/adminComponents/AdminPanel';
import LeadSplit from './components/BOD/BodComponents/LeadSplit';

import LeadUploadPanel from './components/CommonComponents/LeadUploadPanel';

import LeadDbMain from './components/LeadsDbComponents/LeadDbMain';

import Login from './components/loginComponent/Login';
import ForgetPassword from './components/loginComponent/ForgetPassword';
import KanbanBoard from './components/pipelineComponents/KanbanBoard';



import Analytics from './components/AnalyticsComponent/Analytics';

import TagInput from './components/SetupComponents/Interest & Sources Component/TagInput';
import Pipeline from './components/pipelineComponents/Pipeline';

import MyProfile from './components/SetupComponents/MyProfile';
import Card from './components/pipelineComponents/Card';
// import Property from './components/SetupComponents/PropertyComponent/Property';
// import Counter from './components/SetupComponents/PropertyComponent/AddCounter';

import BodBulkUpload from './components/BOD/BodComponents/BodBulkUpload';
import BodLeadUploadPanel from './components/BOD/BodComponents/BodLeadUploadPanel';
import BodManualUpload from './components/BOD/BodComponents/BodManualUpload';
import BodPanel from './components/BOD/BodComponents/BodPanel';
import LeadInfo from './components/LeadsDbComponents/LeadInfo';
import 'primereact/resources/themes/saga-blue/theme.css';  // or any other theme you prefer
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import ResetPassword from './components/loginComponent/ResetPassword';
import ErrorPage from './ErrorPage';
import ReportMain from './components/ReportComponent/ReportMain';
import ReAssignLead from './components/LeadsDbComponents/ReAssignLead';
import LeadSplitToTeam from './components/LeadsDbComponents/LeadSplitToTeam'
import MarketingHub from './components/SetupComponents/MarketingHubComponent/MarketingHub';
import MarketingHubInfo from './components/SetupComponents/MarketingHubComponent/MarketingHubInfo';
import CreateTextAndImageTemplate from './components/SetupComponents/MarketingHubComponent/CreateTextAndImageTemplate';
import TemplateBulkSend from './components/SetupComponents/MarketingHubComponent/TemplateBulkSend';
import UpdateTextAndImageTemplate from './components/SetupComponents/MarketingHubComponent/UpdateTextAndImageTemplate';
import SpinWheel from './components/SetupComponents/SpinWheelComponent/SpinWheel';
import SpinWheelCreation from './components/SetupComponents/SpinWheelComponent/SpinWheelCreation';
import CreateDocumentTemplate from './components/SetupComponents/MarketingHubComponent/CreateDocumentTemplate';
import SpinWheelEditor from './components/SetupComponents/SpinWheelComponent/SpinWheelEditor';
import GLpageCreatingSection from './components/SetupComponents/GLpagesComponents/GLpageCreatingSection';
import GLpagesViewList from './components/SetupComponents/GLpagesComponents/GLpagesViewList';

import ReAssignIndividualLead from './components/LeadsDbComponents/ReAssignIndividualLead';
import ImageUploaderTemplate from './components/SetupComponents/MarketingHubComponent/ImageUploaderTemplate';
import LinkUploaderTemplate from './components/SetupComponents/MarketingHubComponent/LinkUploaderTemplate';
import ChannelPartnerMainPage from './components/SetupComponents/ChannelPartnerComponent/ChannelPartnerMainPage';
import NewPermissionList from './components/SetupComponents/ChannelPartnerComponent/NewPermissionList';
import UnassignLeadsList from './components/SetupComponents/ChannelPartnerComponent/UnassignLeadsList';
import AssignTeamMemberPage from './components/SetupComponents/ChannelPartnerComponent/AssignTeamMemberPage';
import Leadfilter from './components/LeadsDbComponents/Leadfilter';
import AssignSummary from './components/LeadsDbComponents/AssignSummary';
import UnassignedLead from './components/LeadsDbComponents/UnassignedLead';
import ReasignMain from './components/LeadsDbComponents/LeadReasignSection/ReasignMain';
import AutoMessageMain from './components/SetupComponents/AutomatedMessageComponents/AutoMessageMain';
import { ToastContainer } from 'react-toastify';
import PiplineUserDeals from './components/pipelineComponents/PiplineUserDeals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GLpagesCreateTamplate from './components/SetupComponents/GLpagesComponents/GLpagesCreateTamplate';
import IntegrationMainPage from './components/SetupComponents/WebHooksComponent/IntegrationMainPage';
import ConnectedPage from './components/SetupComponents/WebHooksComponent/ConnectedPage';
import FormLeadList from './components/SetupComponents/WebHooksComponent/FormLeadList';
import PropertiesListCard from './components/SetupComponents/PropertiesComponents/PropertiesListCard';
import LayoutPropertyManage from './components/SetupComponents/PropertiesComponents/LayoutPropertySection/LayoutPropertyManage';
import PropertyInventory from './components/SetupComponents/Property Inventory/PropertyInventory';
import VillaProertyManage from './components/SetupComponents/PropertiesComponents/VillaPropertySection/VillaProertyManage';
import ApartmentPropertyManage from './components/SetupComponents/PropertiesComponents/ApartmentPropertySection/ApartmentPropertyManage';

import HotLeadList from './components/HotLeadComponent/HotLeadList';
import SetupNavigationManager from './components/SetUpNavigationComponent/SetupNavigationManager';
import CustomAPIMainContent from './components/SetupComponents/CustomAPIComponents/CustomAPIMainContent';
import InterestAndSourceMain from './components/SetupComponents/Interest&SourceComponents/InterestAndSourceMain';
import TeamList from './components/SetupComponents/TeamComponents/TeamList';
import UserList from './components/SetupComponents/UserComponents/UserList';
import BulkLeadUploadHistoryList from './components/LeadsDbComponents/BulkLeadUploadedHistorySection/BulkLeadUploadHistoryList';
import BulkLeadUploadData from './components/LeadsDbComponents/BulkLeadUploadedHistorySection/BulkLeadUploadData';
import AssignMain from './components/LeadsDbComponents/LeadAssignSection/AssignMain';
import AssignSummaryList from './components/LeadsDbComponents/AssignSummarySection/AssignSummaryList';
import EstimateList from './components/SetupComponents/PropertiesComponents/EstimateSection/EstimateList';
import UserAnalyticsData from './components/BOD/AnalyticsComponent/UserAnalyticsData';
import FollowUpsMain from './components/FollowupsComponent/FollowUpsMain';

const queryClient = new QueryClient();
// import BodPipeline from './components/BOD/BodComponents/pi';

function App() {
  const userRole = JSON.parse(localStorage?.getItem("userData"))?.user?.role;

  return (
    <div className="App font-inter bg-appGrayBackground h-screen">
      <ToastContainer/>
      <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path='/login' element={<Login />} />

    
        <Route path='/forget-password' element={<ForgetPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        {userRole === "Lead Uploader" && (
          <>
          <Route path='/lead-uploader' element={<AdminLeadUploadPanel/>}/>
          <Route path='lead-uploader/lead-upload/manual' element={<AdminManualUpload/>}/>
          <Route path='/lead-uploader/lead-upload/bulk' element={<AdminBulkUpload/>}/>
          <Route path='/lead-uploader/my-profile' element={<MyProfile/>}/>
        <Route path='/' element={<Navigate to="/lead-uploader"/>}/>

          <Route path='/*' element={<ErrorPage />} />


                    </>
        )}
        {userRole === "Admin" && (
          <>
            <Route path='/admin/dashboard' element={<AdminPanel />} />
            <Route path='/admin/analytics' element={<Analytics />} />
            <Route path='/admin/pipeline' element={<Pipeline />} />
            <Route path='/admin/lead-db' element={<LeadDbMain />} />
            <Route path='/admin/report' element={<ReportMain />} />

            <Route path='/admin/lead-upload' element={<LeadUploadPanel/>} />

            <Route path='/admin/lead-upload/manual' element={<AdminManualUpload />} />

            <Route path='/admin/lead-upload/bulk' element={<AdminBulkUpload />} />
            <Route path='/admin/lead-info/:leadId' element={<LeadInfo />} />
            <Route path ='/admin/lead/reassign' element = {<ReAssignIndividualLead/>}/>
            {/* <Route path='/admin/not-interested' element={<NotInterestedLeads />} />
            <Route path='/admin/retry-suitable' element={<RetrySuitableLead />} /> */}
            <Route path='/admin/reassign-lead' element={<ReAssignLead />} />
            <Route path='/admin/leadSplit-teamWise' element={<LeadSplitToTeam />} />


            {/* <Route path='/admin/sale-team' element={<SaleTeam />} /> */}
            <Route path='/admin/sale-team' element={<TeamList />} />
            
         
          
            <Route path='/admin/users' element={<UserList />} />
            <Route path='/admin/follow-ups' element={<FollowUpsMain />} />
       

            <Route path='/admin/properties-list' element={<PropertiesListCard/>} />


            <Route path='/admin/layout-properties-manage' element={<LayoutPropertyManage/>} />
            <Route path='/admin/villa-properties-manage' element={<VillaProertyManage/>} />
            <Route path='/admin/apartment-properties-manage' element={<ApartmentPropertyManage />} />



            <Route path='/admin/property-inventory' element={<PropertyInventory />} />



            <Route path='/admin/web-hooks' element={<IntegrationMainPage/>} />
            <Route path='/admin/web-hooks-connected-page' element={<ConnectedPage/>} />
            <Route path='/admin/web-hooks-form-list' element={<FormLeadList/>} />

            

            {/* <Route path='/admin/interest-sources' element={<InterestAndSources />} /> */}
            <Route path='/admin/interest-sources' element={<InterestAndSourceMain />} />

            <Route path='/admin/tag-input' element={<TagInput />} />
            <Route path='/admin/marketingHub-groupinfo/:id' element={<MarketingHubInfo />} />
            <Route path='/admin/create-textAndImage-template' element={<CreateTextAndImageTemplate />} />
            <Route path='/admin/update-textAndImage-template' element={<UpdateTextAndImageTemplate />} />
            <Route path='/admin/create-document-template' element={<CreateDocumentTemplate />} />
            <Route path='/admin/image-template' element={<ImageUploaderTemplate />} />
            <Route path='/admin/link-template' element={<LinkUploaderTemplate />} />

            <Route path='/admin/hot-lead' element={<HotLeadList/>} />

            <Route path='/admin/marketing-hub' element={<MarketingHub />} />
            <Route path='/admin/marketing-hub-bulkSend' element={<TemplateBulkSend />} />
            <Route path='/admin/spin-wheel' element={<SpinWheel/>}/>
            <Route path='/admin/spin-wheel-creation' element={<SpinWheelCreation/>}/>
            <Route path='/admin/spin-wheel-editor' element={<SpinWheelEditor/>}/>

            <Route path='/admin/gl-pages-creating' element={<GLpageCreatingSection/>}/>
            <Route path='/admin/gl-pages' element={<GLpagesViewList/>}/>
            <Route path='/admin/gl-pages-template' element={<GLpagesCreateTamplate/>}/>
            <Route path='/admin/auto-message' element={<AutoMessageMain/>}/>
            <Route path='/admin/cp-management' element={<ChannelPartnerMainPage/>}/>
            <Route path='/admin/cp-new-permission-list' element={<NewPermissionList/>}/>
            <Route path='/admin/cp-unassignleads-list' element={<UnassignLeadsList/>}/>
            <Route path='/admin/cp-assign-team-member' element={<AssignTeamMemberPage />} />
            <Route path='/admin/lead/lead-filter' element={<Leadfilter />} />

            <Route path='/admin/lead-assign-summary' element={<AssignSummaryList />} />
            <Route path='/admin/lead-unassign-lead' element={<AssignMain />} />
            <Route path='/admin/lead-reasign-lead' element={<ReasignMain />} />

            <Route path="/admin/user-analytics" element={<UserAnalyticsData />} />
            <Route path='/admin/pipline-user-deal' element={<PiplineUserDeals />} />

            <Route path='/admin/estimate-list' element={<EstimateList />} />


            <Route path='/admin/set-up-manage' element={<SetupNavigationManager/>} />

            <Route path='/admin/custom-api' element={<CustomAPIMainContent /> }/>

            <Route path='/admin/lead-bulk-upload-history' element={<BulkLeadUploadHistoryList />} />
            <Route path='/admin/lead-bulk-upload-data' element={<BulkLeadUploadData />} />


            <Route path='/admin/kanban-board' element={<KanbanBoard />} />

            <Route path='/admin/my-profile' element={<MyProfile />} />
        <Route path='/' element={<Navigate to="/admin/dashboard"/>}/>

            <Route path='/*' element={<ErrorPage />} />
          </>
        )}


{userRole === "CMO" && (
       <>
       <Route path='/cmo/dashboard' element={<AdminPanel />} />
       <Route path='/cmo/analytics' element={<Analytics />} />
       <Route path='/cmo/pipeline' element={<Pipeline />} />
       <Route path='/cmo/lead-db' element={<LeadDbMain />} />
       <Route path='/cmo/report' element={<ReportMain />} />

       <Route path='/cmo/lead-upload' element={<LeadUploadPanel/>} />

       <Route path='/cmo/lead-upload/manual' element={<AdminManualUpload />} />

       <Route path='/cmo/lead-upload/bulk' element={<AdminBulkUpload />} />
       <Route path='/cmo/lead-info/:leadId' element={<LeadInfo />} />
       <Route path ='/cmo/lead/reassign' element = {<ReAssignIndividualLead/>}/>
       {/* <Route path='/cmo/not-interested' element={<NotInterestedLeads />} />
       <Route path='/cmo/retry-suitable' element={<RetrySuitableLead />} /> */}
       <Route path='/cmo/reassign-lead' element={<ReAssignLead />} />
       <Route path='/cmo/leadSplit-teamWise' element={<LeadSplitToTeam />} />
  {/* <Route path='/cmo/sale-team' element={<SaleTeam />} /> */}
  <Route path='/cmo/sale-team' element={<TeamList />} />
            
           
            {/* <Route path='/cmo/users' element={<UserMain />} /> */}
            <Route path='/cmo/users' element={<UserList />} />


            <Route path='/cmo/follow-ups' element={<FollowUpsMain />} />

       <Route path='/cmo/properties-list' element={<PropertiesListCard/>} />


       <Route path='/cmo/layout-properties-manage' element={<LayoutPropertyManage/>} />
       <Route path='/cmo/villa-properties-manage' element={<VillaProertyManage/>} />
       <Route path='/cmo/apartment-properties-manage' element={<ApartmentPropertyManage />} />



       <Route path='/cmo/property-inventory' element={<PropertyInventory />} />

       <Route path='/cmo/estimate-list' element={<EstimateList />} />

       <Route path="/cmo/user-analytics" element={<UserAnalyticsData />} />

       <Route path='/cmo/web-hooks' element={<IntegrationMainPage/>} />
       <Route path='/cmo/web-hooks-connected-page' element={<ConnectedPage/>} />
       <Route path='/cmo/web-hooks-form-list' element={<FormLeadList/>} />

       <Route path='/cmo/interest-sources' element={<InterestAndSourceMain />} />

       <Route path='/cmo/tag-input' element={<TagInput />} />
       <Route path='/cmo/marketingHub-groupinfo/:id' element={<MarketingHubInfo />} />
       <Route path='/cmo/create-textAndImage-template' element={<CreateTextAndImageTemplate />} />
       <Route path='/cmo/update-textAndImage-template' element={<UpdateTextAndImageTemplate />} />
       <Route path='/cmo/create-document-template' element={<CreateDocumentTemplate />} />
       <Route path='/cmo/image-template' element={<ImageUploaderTemplate />} />
       <Route path='/cmo/link-template' element={<LinkUploaderTemplate />} />

       <Route path='/cmo/hot-lead' element={<HotLeadList/>} />

       <Route path='/cmo/marketing-hub' element={<MarketingHub />} />
       <Route path='/cmo/marketing-hub-bulkSend' element={<TemplateBulkSend />} />
       <Route path='/cmo/spin-wheel' element={<SpinWheel/>}/>
       <Route path='/cmo/spin-wheel-creation' element={<SpinWheelCreation/>}/>
       <Route path='/cmo/spin-wheel-editor' element={<SpinWheelEditor/>}/>

       <Route path='/cmo/gl-pages-creating' element={<GLpageCreatingSection/>}/>
       <Route path='/cmo/gl-pages' element={<GLpagesViewList/>}/>
       <Route path='/cmo/gl-pages-template' element={<GLpagesCreateTamplate/>}/>
       <Route path='/cmo/auto-message' element={<AutoMessageMain/>}/>
       <Route path='/cmo/cp-management' element={<ChannelPartnerMainPage/>}/>
       <Route path='/cmo/cp-new-permission-list' element={<NewPermissionList/>}/>
       <Route path='/cmo/cp-unassignleads-list' element={<UnassignLeadsList/>}/>
       <Route path='/cmo/cp-assign-team-member' element={<AssignTeamMemberPage />} />
       <Route path='/cmo/lead/lead-filter' element={<Leadfilter />} />

       <Route path='/cmo/lead-assign-summary' element={<AssignSummaryList />} />
       <Route path='/cmo/lead-unassign-lead' element={<AssignMain />} />
       <Route path='/cmo/lead-reasign-lead' element={<ReasignMain />} />


       <Route path='/cmo/pipline-user-deal' element={<PiplineUserDeals />} />


       <Route path='/cmo/set-up-manage' element={<SetupNavigationManager/>} />

       <Route path='/cmo/custom-api' element={<CustomAPIMainContent /> }/>

       <Route path='/cmo/lead-bulk-upload-history' element={<BulkLeadUploadHistoryList />} />
       <Route path='/cmo/lead-bulk-upload-data' element={<BulkLeadUploadData />} />


       <Route path='/cmo/kanban-board' element={<KanbanBoard />} />

       <Route path='/cmo/my-profile' element={<MyProfile />} />
   <Route path='/' element={<Navigate to="/cmo/dashboard"/>}/>

       <Route path='/*' element={<ErrorPage />} />
     </>
        )}

        {userRole === "MD" && (
          <>
            <Route path='/md/dashboard' element={<AdminPanel />} />
            <Route path='/md/analytics' element={<Analytics />} />
            <Route path="/md/user-analytics" element={<UserAnalyticsData />} />
            <Route path='/md/pipeline' element={<Pipeline />} />
            <Route path='/md/lead-db' element={<LeadDbMain />} />
            <Route path='/md/lead-info/:leadId' element={<LeadInfo />} />
            <Route path='/md/follow-ups' element={<FollowUpsMain />} />

            <Route path='/md/my-profile' element={<MyProfile />} />
        <Route path='/' element={<Navigate to="/md/dashboard"/>}/>

            <Route path='/*' element={<ErrorPage />} />
          </>
        )}

        {userRole === "BOD" && (
          <>
            <Route path='/bod/dashboard' element={<BodPanel />} />
            <Route path='/bod/forget-password' element={<ForgetPassword />} />
            <Route path='/bod/lead-upload' element={<LeadUploadPanel/>} />
            <Route path='/bod/lead-upload/manual' element={<AdminManualUpload />} />
            <Route path='/bod/lead-split' element={<LeadSplit />} />
            <Route path='/bod/lead-upload/bulk' element={<AdminBulkUpload />} />
            <Route path='/bod/analytics' element={<Analytics />} />
            <Route path='/bod/pipeline' element={<Pipeline />} />

            <Route path='/bod/lead-db' element={<LeadDbMain />} />
            <Route path='/bod/lead-info/:leadId' element={<LeadInfo />} />
            <Route path ='/bod/lead/reassign' element = {<ReAssignIndividualLead/>}/>

            <Route path='/bod/lead-assign-summary' element={<AssignSummaryList />} />
            <Route path='/bod/lead-unassign-lead' element={<UnassignedLead />} />
            <Route path='/bod/lead-reasign-lead' element={<ReasignMain />} />
            <Route path="/bod/user-analytics" element={<UserAnalyticsData />} />
          
            <Route path='/bod/follow-ups' element={<FollowUpsMain />} />
            <Route path='/bod/lead-bulk-upload-history' element={<BulkLeadUploadHistoryList />} />
            <Route path='/bod/lead-bulk-upload-data' element={<BulkLeadUploadData />} />

            <Route path='/bod/my-profile' element={<MyProfile />} />
        <Route path='/' element={<Navigate to="/bod/dashboard"/>}/>

            <Route path='/*' element={<ErrorPage />} />
          </>
        )}
       <Route path='/*' element={<Login />} />

      </Routes>
      </QueryClientProvider>
    </div>
  );
}

export default App;

